var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('button',{staticClass:"vs-pagination__arrow prev",staticStyle:{"background-color":"white"},attrs:{"onclick":"go()"}},[_c('h3',[_vm._v("点我前往")])])])
}]

export { render, staticRenderFns }